export default __webpack_public_path__ + "static/media/vehicle_hatchback.5c5134ea.svg";